import {
  collection,
  doc,
  getDocs,
  writeBatch,
} from 'firebase/firestore';

const BATCH_LIMIT = 450;

export async function deleteSupportTicketCascade(db, ticketId) {
  const messagesRef = collection(db, 'supportTickets', ticketId, 'messages');
  const snap = await getDocs(messagesRef);
  const ticketRef = doc(db, 'supportTickets', ticketId);
  let batch = writeBatch(db);
  let count = 0;
  for (const d of snap.docs) {
    batch.delete(d.ref);
    count += 1;
    if (count >= BATCH_LIMIT) {
      await batch.commit();
      batch = writeBatch(db);
      count = 0;
    }
  }
  batch.delete(ticketRef);
  await batch.commit();
}
